import { Table } from "react-bootstrap";

const InformationConsole = ({
  ids,
  isFullScreenMode,
  isFullScreen,
  setIsFullScreen,
}) => {
  const clientLabel = JSON.parse(localStorage.getItem("clientLabel"));
  const projectLabel = JSON.parse(localStorage.getItem("projectLabel"));
  return (
    <div className="overflow-hidden w-100">
      <div
        className="justify-content-between toolbar border-bottom hstack w-100 p-1"
        style={{ height: 35 }}
      >
        <div className="hstack gap-1">
          <i className="fa-solid fa-info"></i>
          <h6 className="m-0">Header Information</h6>
        </div>
        <div className="hstack gap-1">
          <i
            title={`${isFullScreen ? "Minimize" : "Maximize"} Console`}
            className={`fa-solid ${isFullScreen ? "fa-minimize" : "fa-maximize"
              } CP`}
            onClick={() => setIsFullScreen(!isFullScreen)}
          />
        </div>
      </div>
      <div
        className="p-2"
        style={{
          height: isFullScreenMode
            ? "calc(100vh - 70px)"
            : "calc(100vh - 216px)",
          overflowY: "auto",
        }}
      >
        <Table
          className="m-0 border-start border-end custom-table"
          bordered
          hover
          striped
        >
          <thead className="position-sticky top-0">
            <tr>
              <th>Attribute</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Sponsor Name</td>
              <td>{clientLabel}</td>
            </tr>
            <tr>
              <td>Project Id</td>
              <td>{projectLabel}</td>
            </tr>
            <tr>
              <td>Study Id</td>
              <td>{ids?.studyLabel}</td>
            </tr>
            <tr>
              <td>Programmer Name</td>
              <td>{ids?.updatorName}</td>
            </tr>
            <tr>
              <td>Program Name</td>
              <td>
                {ids?.reportName}.glx
              </td>
            </tr>
            <tr>
              <td>Program Location</td>
              <td>
                /Generate Report/Program/{ids?.reportName}.glx
              </td>
            </tr>
            <tr>
              <td>Software Version</td>
              <td>v2.0.0</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default InformationConsole;
